// Copyright (c) Ensho Health, 2022 to present

import actions from '../action';

const defaultState = {
  list: [],
  loading: false,
  error: null
};

export default function cdlReducer(state = defaultState, action) {
  switch (action.type) {
    case actions.cdlServices.ACTION_TYPES.SET_CDL_SERVICES:
      const cdlServices = [...action.payload];
      return {
        ...state,
        list: cdlServices,
        loading: false
      };
    case actions.cdlServices.ACTION_TYPES.ERROR:
      return { ...state, error: action.payload, loading: false };
    case actions.cdlServices.ACTION_TYPES.LOADING:
      return { ...state, loading: true, error: null };
    default:
      return state;
  }
}
